import * as React from 'react';
import * as trial from "./style.module.scss";
import { Modal } from '../../../../Modal';
import { GetCourseWidget } from "../../../../GetCourseWidget";
import {AccessLimited} from "../../../../AccessLimited";

export const Trial = ({ accessLimited }) => {
  const [showModalTrial, setShowModalTrial] = React.useState(false);
  return (
    <section className={trial.trial}>
      <div className="container">
        <div className={trial.trial__wrapper}>
          <div className={trial.trial__content}>
            <h4>Сомневаетесь в&nbsp;эффективности наших технологий?</h4>
            <p><strong>Пройдите бесплатный пробный урок!</strong> <br/>
              Умение эффективно работать с текстом — это преимущество, которое позволит вашим детям добиваться высоких
              результатов в жизни.</p>
            <div className={trial.trial__btnWrap}>
              <button className={trial.trial__btn} onClick={()=>{setShowModalTrial(true)}}>
                Записаться на пробный урок
              </button>
              { accessLimited && <AccessLimited margin={"10px 0 0"} font={"16px"} align={"center"}/> }
            </div>
          </div>
          <div className={trial.trial__img}>
            <img
              src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/photo-freelesson.png"
              alt={""}
            />
          </div>
        </div>
      </div>

      <Modal
        open={showModalTrial}
        onClose={() => {
          setShowModalTrial(false);
        }}
      >
        <GetCourseWidget hash={'c478af313a76f38ac94b217f63520ba59456be49'} id={'739123'} />
      </Modal>
    </section>
  );
};
